import React from 'react';
import { translate } from '@utils/i18n';
import { namespace } from './constants';
import LocationDisplay from '../../FormLibrary/LocationDisplay';
const getColumnsDefinition = ({ onClickItem }) => [
    {
        label: translate('headers.display_name', { namespace }),
        dataKey: 'displayName',
        renderer: ({ item }) => {
            var _a;
            return (React.createElement("div", null, ((_a = item.template) === null || _a === void 0 ? void 0 : _a.pdfFileUrl) ? (React.createElement("a", { href: item.template.pdfFileUrl, target: "_blank", rel: "noopener noreferrer" }, item.displayName)) : (React.createElement("span", null, item.displayName))));
        }
    },
    {
        label: translate('headers.location', { namespace }),
        dataKey: 'location',
        renderer: ({ item }) => {
            var _a, _b, _c;
            return (React.createElement(LocationDisplay, { city: (_a = item.template) === null || _a === void 0 ? void 0 : _a.city, state: (_b = item.template) === null || _b === void 0 ? void 0 : _b.state, country: (_c = item.template) === null || _c === void 0 ? void 0 : _c.country }));
        }
    },
    {
        label: '',
        dataKey: 'id',
        renderer: ({ item }) => (React.createElement("button", { type: "button", title: "Edit Details", className: "qmb-control--icon", onClick: () => onClickItem(item) },
            React.createElement("i", { className: "fa-light fa-pencil", "aria-hidden": "true" })))
    }
];
export default getColumnsDefinition;
